import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import store from "../../../state/store";
import querystring from "querystring";

// UI Components
import { Container, Card, CardBody } from "reactstrap";
import { Group } from "../../../utils/logger";
import Avaliabletemplates from "./Scripting.tables";
import Select from "react-select";
import Header from "./Header";

// State
import { getOnDemandTemplates, setSelectedOptions } from "../../../state/actions/templateActions";

class OnDemand extends Component {
  constructor(props) {
    super(props);
    const query_string = window.location.search.replace(/^\?/, "");
    const query_object = querystring.parse(query_string);
    this.state = {
      queryObject: query_object,
      search_text: "",
      filterType: "",
      filterSubType: "",
      filterCompanyCode: "",
      filterData: [],
      templates: [],
      user: "",
      // Modal
      modal: {
        type: "add",
        isOpen: false,
        applyChanges: null,
      },
    };
    store.subscribe(() => {
      this.setState({
        user: store.getState().user.user,
      });
    });

    this.LoggerGroup = new Group("Templates", { disable: true });

    this.handleChangeType = this.handleChangeType.bind(this);
    this.handleChangeSubType = this.handleChangeSubType.bind(this);
    this.handleChangeCompanyCode = this.handleChangeCompanyCode.bind(this);
    this.checkParams = this.checkParams.bind(this);
  }

  async componentDidMount() {
    this.LoggerGroup.emit("Mounted").end();
    await this.props.getOnDemandTemplates("active", store.getState().user.user.group_id_bint);
    await this.setState({ templates: this.props.templates });
    await this.checkParams();
  }

  handleChangeCompanyCode = (filterCompanyCode) => {
    this.setState({ filterCompanyCode });
    this.props.setSelectedOptions({
      ...this.props.selectedOptions,
      companyCode: filterCompanyCode,
    });
  };
  handleChangeType = (filterType) => {
    this.setState({ filterType });
    this.props.setSelectedOptions({
      ...this.props.selectedOptions,
      type: filterType,
    });
  };

  handleChangeSubType = (filterSubType) => {
    this.setState({ filterSubType });
    this.props.setSelectedOptions({
      ...this.props.selectedOptions,
      subType: filterSubType,
    });
  };
  checkParams = () => {
    if (this.state.queryObject) {
      if (this.state.queryObject.companyCode) {
        this.handleChangeCompanyCode({
          label: this.state.queryObject.companyCode,
          value: this.state.queryObject.companyCode,
        });
      }
      if (this.state.queryObject.type) {
        this.handleChangeType([
          { label: this.state.queryObject.type, value: this.state.queryObject.type },
        ]);
      }
      if (this.state.queryObject.subtype) {
        this.handleChangeSubType([
          { label: this.state.queryObject.subtype, value: this.state.queryObject.subtype },
        ]);
      }
    }
  };

  getUnique(arr, comp, filter = []) {
    if (comp === "subtype" && filter) {
      let filterDefinitions = [];
      for (let index = 0; index < filter.length; ++index) {
        let data = filter[index];
        filterDefinitions.push(data.value ? data.value.toLowerCase() : data.toLowerCase());
      }
      filterDefinitions = new Set(filterDefinitions);
      arr = arr.filter((d) => filterDefinitions.has(d.type.toLowerCase()));
    }
    const unique = arr
      .map((e) => e[comp])
      .map((e, i, final) => final.indexOf(e) === i && i)
      .filter((e) => arr[e])
      .map((e) => arr[e]);
    return unique;
  }

  dataScrubbing(filter) {
    let scrubbedData = [];
    for (let index = 0; index < filter.length; ++index) {
      let data = filter[index];
      scrubbedData.push(data.value ? data.value.toLowerCase() : data.toLowerCase());
    }
    return scrubbedData;
  }

  render() {
    const { templates } = this.state;
    let { type, subType } = this.props.selectedOptions;
    const filterData = templates;

    let uniqueCompanyCode = this.getUnique(filterData, "companyCode").map((data) => {
      return { label: data.companyCode, value: data.companyCode };
    });
    uniqueCompanyCode.unshift({ label: "ALL", value: "" });

    let uniqueType = this.getUnique(filterData, "type").map((data) => {
      return { label: data.type, value: data.type };
    });

    let uniqueSubType = this.getUnique(filterData, "subtype", type).map((data) => {
      return { label: data.subtype, value: data.subtype };
    });

    return (
      <Container fluid className="p-0">
        <Header />

        <Card>
          <CardBody>
            <div className="container-fluid p-0">
              <div className="row">
                <div className="col-lg">
                  {"Type:   "}
                  <Select
                    isMulti
                    onChange={this.handleChangeType}
                    options={uniqueType}
                    value={type}
                    isClearable={false}
                  />
                </div>
                <div className="col-lg">
                  {"Sub Type:   "}
                  <Select
                    isMulti
                    onChange={this.handleChangeSubType}
                    options={uniqueSubType}
                    value={subType}
                    isClearable={false}
                  />
                </div>
              </div>
            </div>
          </CardBody>
        </Card>

        <Card>
          <CardBody>
            {filterData && filterData.length > 0 ? (
              <Avaliabletemplates
                data={filterData}
                filter1={
                  this.props.selectedOptions.type
                    ? this.dataScrubbing(this.props.selectedOptions.type)
                    : ""
                }
                filter2={
                  this.props.selectedOptions.subType
                    ? this.dataScrubbing(this.props.selectedOptions.subType)
                    : ""
                }
                filter3={
                  this.props.selectedOptions.companyCode
                    ? this.props.selectedOptions.companyCode.value
                    : ""
                }
              />
            ) : (
              " "
            )}
          </CardBody>
        </Card>
      </Container>
    );
  }
}

OnDemand.propTypes = {
  loading: PropTypes.object.isRequired,
  getOnDemandTemplates: PropTypes.func.isRequired,
  selectedOptions: PropTypes.object.isRequired,
  setSelectedOptions: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => ({
  loading: state.templates.loading,
  templates: state.templates.list,
  selectedTemplate: state.templates.selected,
  selectedOptions: state.templates.selectedOptions,
});

export default connect(mapStateToProps, {
  getOnDemandTemplates,
  setSelectedOptions,
})(OnDemand);
